import { combineReducers } from 'redux';
import update from 'react-addons-update'; // cf https://facebook.github.io/react/docs/update.html

export function episodes(state = window.STATE_FROM_SERVER, action) {
  switch (action.type) {
    case 'EPISODE_UPDATE_CURRENT':
      return Object.assign(state, {
          currentEpisodeId: action.episodeId,
          currentEpisode: state.episodes[action.episodeId]
      })

    case 'EPISODE_ADD':
      var arr = state.episodes.episodes || [];
      arr[action.index] = action.data
      return update(state, {
        episodes: {$set: arr}
      })

    case 'EPISODE_GET_CURRENT':
      return state.episodes[state.currentEpisodeId]
    default:
      return state
  }
}

export function gallery(state = window.STATE_FROM_SERVER, action){
  switch (action.type) {
    case 'GALLERY_OPEN':
      return update(state, {
        open: {$set:true}
      })

    case 'GALLERY_CLOSE':
      return update(state, {
        open: {$set:false}
      })

    case 'GALLERY_UPDATE_CURRENT_SLIDE':
      return update(state, {
        currentSlide: {$set: action.index}
      })

    default:
      return state
  }
}

export function quizz(state = window.STATE_FROM_SERVER, action){
  switch (action.type) {
    case 'QUIZZ_CREATE':
      var arr = state.quizzes || [];
      if(arr[parseInt(action.quizzId)]){
        arr[parseInt(action.quizzId)].answers = arr[parseInt(action.quizzId)].answers || [];
      }else{
        arr[parseInt(action.quizzId)] = { answers: [], currentSlide: 0 }
      }
      return update(state, { quizzes: {$set: arr} })

    case 'QUIZZ_DESTROY':
      return update(state, {
        quizzes: {$splice: [[action.index , 1]]}
      })

    case 'QUIZZ_UPDATE_CURRENT_SLIDE':
      var quizz_arr = state.quizzes || [];
      quizz_arr[action.quizzId] = quizz_arr[action.quizzId] || {};
      quizz_arr[action.quizzId].currentSlide = action.index;
      return update(state, {
        quizzes: { $set: quizz_arr }
      })

    case 'QUIZZ_SAVE_ANSWER':
      var completed = true,
        quizz_arr = state.quizzes || [],
        currentScore = 0,
        finalScore = undefined;

      quizz_arr[action.quizzId] = quizz_arr[action.quizzId] || [];
      quizz_arr[action.quizzId].answers = quizz_arr[action.quizzId].answers || [];
      quizz_arr[action.quizzId].answers[action.questionIndex] = parseInt(action.answerValue);
      quizz_arr[action.quizzId].answers = quizz_arr[action.quizzId].answers.map(function(answer, index){
        if(index != 0){
          if(parseInt(answer) > -1 ) {
            currentScore += answer;
          }else{
            completed = false;
          }
          return answer;
        }
      });

      if (completed){
        finalScore = Math.floor((currentScore / (2*3)) * 100);
      }

      quizz_arr[action.quizzId].completed = completed;
      quizz_arr[action.quizzId].currentScore = currentScore;
      quizz_arr[action.quizzId].finalScore = finalScore;

      return update(state, {
        quizzes: { $merge: quizz_arr }
      })

    case 'QUIZZ_RESET_ANSWERS':
      var quizz_arr = state.quizzes || [];
      quizz_arr[action.quizzId] = quizz_arr[action.quizzId] || {};
      quizz_arr[action.quizzId].answers = [];
      quizz_arr[action.quizzId].completed = false;
      quizz_arr[action.quizzId].currentScore = null;
      quizz_arr[action.quizzId].finalScore = null;
      return update(state, {
        quizzes: { $merge: quizz_arr }
      })

    default:
      return state
  }
}

export default combineReducers({
  episodes,
  gallery,
  quizz
});



// WEBPACK FOOTER //
// ./src/reducers/index.js